import request from "@/utils/request";

let PointGoodsApi = {
    /*商品列表*/
    goodsList(data, errorback) {
        return request._post("/merch/plus.points.goods/index", data, errorback);
    },
    /*添加商品*/
    addGoods(data, errorback) {
        return request._post("/merch/plus.points.goods/add", data, errorback);
    },
    /*获取详情*/
    getGoods(data, errorback) {
        return request._get("/merch/plus.points.goods/add", data, errorback);
    },
    /*获取积分商品*/
    getPointGoods(data, errorback) {
        return request._get("/merch/plus.points.goods/edit", data, errorback);
    },
    /*编辑积分商品*/
    editPointGoods(data, errorback) {
        return request._post("/merch/plus.points.goods/edit", data, errorback);
    },
    /*删除商品*/
    deleteGoods(data, errorback) {
        return request._post("/merch/plus.points.goods/delete", data, errorback);
    },
    /*保存配置*/
    saveConfig(data, errorback) {
        return request._post("/merch/plus.points.goods/settings", data, errorback);
    },
    /*保存配置*/
    getConfig(data, errorback) {
        return request._get("/merch/plus.points.goods/settings", data, errorback);
    },
    /*获取兑换记录*/
    getExchange(data, errorback) {
        return request._post("/merch/plus.points.goods/record", data, errorback);
    }
};
export default PointGoodsApi;



// WEBPACK FOOTER //
// ./src/api/pointgoods.js